import React, {useState,useEffect} from 'react';
import {Formulario, Input, Etiqueta, ContenedorBoton, ContenedorSelect, ContenedorGrupoSelect, ContenedorInputsObjeto, ContenedorInputsObjetoUnidad} from '../elementos/ElementosDeFormulario'
import Boton from '../elementos/Boton'
import SelectMaterial from './SelectMaterial';
import SelectCultura from './SelectCultura';
import SelectUbicacion from './SelectUbicacion';
import Api from '../servicios/api';
import Alerta from '../elementos/Alerta'
import {useAuth} from "./../contextos/AuthContext";
import { useNavigate } from "react-router-dom";

const FormularioObjeto = ({objeto}) => {
    const {idUsuario} = useAuth();
    const [inputCodigoActual, setInputCodigoActual] = useState('')
    const [inputDescripcion, setInputDescripcion] = useState('')
    const [inputEstado, setInputEstado] = useState('')
    const [inputPorcIntegridad, setInputPorcIntegridad] = useState('')
    const [inputPorcConservacion, setInputPorcConservacion] = useState('')
    const [inputObservaciones, setInputObservaciones] = useState('')
    const [selectedFile, setSelectedFile] = useState(null);
    const [inputRutaImagen, setInputRutaImagen] = useState(null);
    const [imagenEliminar, setImagenEliminar] = useState(null);
    const [selectMaterial, setSelectMaterial] = useState([])
    const [selectMaterialActive, setSelectMaterialActive] = useState(false)
    const [selectCultura, setSelectCultura] = useState([])
    const [selectCulturaActive, setSelectCulturaActive] = useState(false)
    const [selectUbicacion, setSelectUbicacion] = useState([])
    const [selectUbicacionActive, setSelectUbicacionActive] = useState(false)
    const [estadoAlerta, setEstadoAlerta] = useState(false)
    const [alerta, setAlerta] = useState({})
    const navigate = useNavigate()

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        if(objeto){
            setInputCodigoActual(objeto.Obj_CodigoActual);
            setInputDescripcion(objeto.Obj_Descripcion);
            setInputEstado(objeto.Obj_Estado);
            setInputPorcIntegridad(objeto.Obj_PorcIntegridad);
            setInputPorcConservacion(objeto.Obj_PorcConservacion);
            setInputObservaciones(objeto.Obj_Observaciones);
            setInputRutaImagen(objeto.Obj_RutaImagen);
            setImagenEliminar(objeto.Obj_RutaImagen);
            setSelectMaterial({Mat_ID:objeto.Mat_ID, Mat_Nombre:objeto.Mat_Nombre});
            setSelectCultura({Cul_ID:objeto.Cul_ID, Cul_Nombre:objeto.Cul_Nombre});
            setSelectUbicacion({Ubi_ID:objeto.Ubi_ID, Ubi_Nombre:objeto.Ubi_Nombre});
        }
    }, [objeto]);

    const handleChange = (e) => {
        switch(e.target.name){
            case 'codigo':
                setInputCodigoActual(e.target.value);
                break;
            case 'descripcion':
                setInputDescripcion(e.target.value);
                break;
            case 'estado':
                setInputEstado(e.target.value);
                break;
            case 'porcIntegridad':
                setInputPorcIntegridad(e.target.value.replace(/[^0-9]/g, ''));
                break;
            case 'porcConservacion':
                setInputPorcConservacion(e.target.value.replace(/[^0-9]/g, ''));
                break;
            case 'observaciones':
                setInputObservaciones(e.target.value);
                break;
            case 'imagen':
                setInputRutaImagen(e.target.files[0].name);
                setSelectedFile(e.target.files[0]);
                break;
            default:
                break;
        }
    }

    const offSelectsCulturaUbicacion = () => {
        setSelectMaterialActive(!selectMaterialActive)
        setSelectCulturaActive(false)
        setSelectUbicacionActive(false)
    }

    const offSelectsMaterialUbicacion = () => {
        setSelectCulturaActive(!selectCulturaActive)
        setSelectMaterialActive(false)
        setSelectUbicacionActive(false)
    }

    const offSelectsMaterialCultura = () => {
        setSelectUbicacionActive(!selectUbicacionActive)
        setSelectMaterialActive(false)
        setSelectCulturaActive(false)
    }

    const almacenarImagen = () => {
        const formdata = new FormData()
        formdata.append('image', selectedFile)

        fetch(Api+"?subirImagen", {
            method: "POST",
            body: formdata
        })
        .then((response) => response.json())
        .then((data) => {
          // Procesar la respuesta del servidor
          console.log(data);
        })
        .catch((error) => {
            // Manejar errores
            console.error(error);
        })
    }

    const actualizarImagen = () => {
        const formdata = new FormData()
        formdata.append('image', selectedFile)
        console.log(selectedFile)

        fetch(Api+"?actualizarImagen="+objeto.Obj_ID, {
            method: "POST",
            body: formdata
        })
        .then((response) => response.json())
        .then((data) => {
          // Procesar la respuesta del servidor
          console.log(data);
        })
        .catch((error) => {
            // Manejar errores
            console.error(error);
        })
    }
    
    const handleSubmit = (e) => {
        e.preventDefault();
        setEstadoAlerta(false);
        setAlerta({});

        // Validaciones del lado del cliente para que los inputs no esten vacios
        if(inputCodigoActual === '' || inputDescripcion === '' || inputEstado === '' || inputDescripcion === '' || inputPorcIntegridad === '' || inputPorcConservacion === '' || selectMaterial.Mat_ID === 0 || selectCultura.Cul_ID === 0 || selectUbicacion.Ubi_ID === 0){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los datos'
            });
            return;
        }

        var datosEnviar;
        if(!objeto){
            datosEnviar = {codigo:inputCodigoActual, descripcion:inputDescripcion, estado:inputEstado, porcIntegridad:inputPorcIntegridad, porcConservacion:inputPorcConservacion, observaciones:inputObservaciones, imagen:inputRutaImagen, idMaterial:selectMaterial.Mat_ID, idCultura:selectCultura.Cul_ID, idUbicacion:selectUbicacion.Ubi_ID, idUser:idUsuario}
            console.log(datosEnviar)
            fetch(Api+"?insertarObjeto",{
                method:"POST",
                body: JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                if(datosRespuesta.success === 1){
                    if(selectedFile){
                        almacenarImagen();
                    }
                    
                    setInputCodigoActual('');
                    setInputDescripcion('');
                    setInputEstado('');
                    setInputObservaciones('');
                    setInputPorcIntegridad('');
                    setInputPorcConservacion('');
                    document.getElementById('inputFile').value = null;
                    setInputRutaImagen(null);
                    setSelectMaterial({Mat_ID:0, Mat_Nombre: 'Seleccione Material'});
                    setSelectCultura({Cul_ID:0, Cul_Nombre: 'Seleccione Cultura'});
                    setSelectUbicacion({Ubi_ID:0, Ubi_Nombre: 'Seleccione Ubicación'});
                    setEstadoAlerta(true);
                    //console.log(selectedFile.name)
                    setAlerta({
                        tipo: 'exito',
                        mensaje: 'Objeto registrado correctamente.'
                    });
                    
                }
                else{
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'error',
                        mensaje: 'Error al agregar objeto.'
                    });
                }
                
            })
            .catch(console.log)
        }
        else{
            datosEnviar = {id:objeto.Obj_ID, codigo:inputCodigoActual, descripcion:inputDescripcion, estado:inputEstado, porcIntegridad:inputPorcIntegridad, porcConservacion:inputPorcConservacion, observaciones:inputObservaciones, imagen:inputRutaImagen, imagenEliminar:imagenEliminar, idMaterial:selectMaterial.Mat_ID, idCultura:selectCultura.Cul_ID, idUbicacion:selectUbicacion.Ubi_ID, idUser:idUsuario}
            console.log(datosEnviar)
            fetch(Api+"?actualizarObjeto",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                console.log(datosRespuesta)
                if(selectedFile){
                    actualizarImagen();
                }
                navigate("/objetos");
            })
            .catch(console.log)
        }
    }

    return (
        <>
            <Formulario onSubmit={handleSubmit}>
                <div>
                    <Etiqueta htmlFor="">Código Actual</Etiqueta>
                    <Input
                        type="text"
                        name="codigo"
                        placeholder="Ingrese Código Actual"
                        value={inputCodigoActual}
                        onChange={handleChange}
                    />

                    <Etiqueta htmlFor="">Descripción</Etiqueta>
                    <Input
                        type="text"
                        name="descripcion"
                        placeholder="Ingrese Descripción"
                        value={inputDescripcion}
                        onChange={handleChange}
                    />
                    
                    <ContenedorInputsObjeto>
                        <ContenedorInputsObjetoUnidad>
                            <Etiqueta htmlFor="">Estado</Etiqueta>
                            <Input
                                type="text"
                                name="estado"
                                placeholder="Ingrese Estado"
                                value={inputEstado}
                                onChange={handleChange}
                            />
                        </ContenedorInputsObjetoUnidad>

                        <ContenedorInputsObjetoUnidad>
                            <Etiqueta htmlFor="">Porcentaje de Integridad</Etiqueta>
                            <Input
                                type="text"
                                name="porcIntegridad"
                                placeholder="Ingrese Porcentaje de Integridad"
                                value={inputPorcIntegridad}
                                onChange={handleChange}
                            />
                        </ContenedorInputsObjetoUnidad>

                        <ContenedorInputsObjetoUnidad>
                            <Etiqueta htmlFor="">Porcentaje de Conservación</Etiqueta>
                            <Input
                                type="text"
                                name="porcConservacion"
                                placeholder="Ingrese Porcentaje de Conservación"
                                value={inputPorcConservacion}
                                onChange={handleChange}
                            />
                        </ContenedorInputsObjetoUnidad>

                    </ContenedorInputsObjeto>

                    <Etiqueta htmlFor="">Observaciones</Etiqueta>
                    <Input
                        type="text"
                        name="observaciones"
                        placeholder="Ingrese Observaciones"
                        value={inputObservaciones}
                        onChange={handleChange}
                    />
                </div>
                
                <ContenedorGrupoSelect>
                    <ContenedorSelect>
                        <Etiqueta htmlFor="">Material</Etiqueta>
                        <SelectMaterial
                            selectMaterial={selectMaterial}
                            setSelectMaterial={setSelectMaterial}
                            mostrarSelect={selectMaterialActive}
                            desactivarSelects={offSelectsCulturaUbicacion}
                        />
                    </ContenedorSelect>

                    <ContenedorSelect>
                        <Etiqueta htmlFor="">Cultura</Etiqueta>
                        <SelectCultura
                            selectCultura={selectCultura}
                            setSelectCultura={setSelectCultura}
                            mostrarSelect={selectCulturaActive}
                            desactivarSelects={offSelectsMaterialUbicacion}
                        />
                    </ContenedorSelect>

                    <ContenedorSelect>
                        <Etiqueta htmlFor="">Ubicación</Etiqueta>
                        <SelectUbicacion
                            selectUbicacion={selectUbicacion}
                            setSelectUbicacion={setSelectUbicacion}
                            mostrarSelect={selectUbicacionActive}
                            desactivarSelects={offSelectsMaterialCultura}
                        />
                    </ContenedorSelect>
                </ContenedorGrupoSelect>

                <Etiqueta htmlFor="">Imagen: {inputRutaImagen}</Etiqueta>
                <input 
                    type="file"
                    name="imagen"
                    id="inputFile"
                    onChange={handleChange}/>

                <ContenedorBoton>
                        <Boton to="/objetos">Cancelar</Boton>
                        <Boton as="button" type="submit" primario="true">
                            {objeto ? 'Actualizar' : 'Guardar'} 
                        </Boton>
                </ContenedorBoton>
            </Formulario>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setEstadoAlerta={setEstadoAlerta}
            />
        </>
    );
}
 
export default FormularioObjeto;